import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Toast, PullToRefresh, List } from "antd-mobile";
import { getChatList } from "@/api/airportTransfer";
import { getLocationSearch } from "@/utils/utils";
import { useTranslation } from '@/i18n';
import messageImg from "@/assets/images/message.png";
import "./index.scss";

const MessageCenter = () => {
  const [messageList, setMessageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const history = useHistory();
  const t = useTranslation();

  useEffect(() => {
    document.title = t('messageCenter.title');
    // 设置页面标题（如果在 WebView 中）
    if (typeof window?.savePicture?.setTitle === "function") {
      window?.savePicture?.setTitle(t('messageCenter.title'));
    }

    // 检查登录状态
    const token =
      getLocationSearch().token || localStorage.getItem("userToken") || "";
    if (!token) {
      Toast.fail(t('messageCenter.loginRequired'), 2);
      //   history.replace('/login');
      return;
    }

    // 获取消息列表
    fetchMessageList();
  }, [history]);

  // 获取消息列表
  const fetchMessageList = async (page = 1, isRefresh = false) => {
    if (loading) return;

    setLoading(true);
    try {
      const result = await getChatList({});
      console.log("消息列表", result);

      if (result.data.errorCode === 0) {
        const newMessages = result.data.data.datas || [];

        if (isRefresh || page === 1) {
          setMessageList(newMessages);
        } else {
          setMessageList((prev) => [...prev, ...newMessages]);
        }

        setCurrentPage(page);
        setHasMore(newMessages.length === 20);
      } else if (result.errorCode === 110004) {
        Toast.fail(result.errorMsg || "请先登录", 2);
        history.replace("/login");
      } else {
        Toast.fail(result.errorMsg || t('messageCenter.fetchFailed'), 2);
      }
    } catch (error) {
      console.error("获取消息列表失败", error);
      Toast.fail(t('messageCenter.networkError'), 2);
    } finally {
      setLoading(false);
    }
  };

  // 下拉刷新
  const onRefresh = async () => {
    await fetchMessageList(1, true);
  };

  // 加载更多
  const loadMore = async () => {
    if (hasMore && !loading) {
      await fetchMessageList(currentPage + 1);
    }
  };

  // 解析消息内容
  const parseMessageContent = (msgContent, msgType) => {
    try {
      const content = JSON.parse(msgContent);
      if (msgType === 1) {
        // 文本消息
        return content.text || "";
      } else if (msgType === 4) {
        // 图片消息
        return t('messageCenter.imageMessage');
      }
      return msgContent;
    } catch (error) {
      return msgContent;
    }
  };

  // 获取订单类型文本
  const getOrderTypeText = (orderType) => {
    switch (orderType) {
      case 1:
        return t('messageCenter.orderType.express');
      case 2:
        return t('messageCenter.orderType.carpool');
      case 3:
        return t('messageCenter.orderType.airport');
      default:
        return t('messageCenter.orderType.unknown');
    }
  };

  // 格式化时间
  const formatTime = (timeStr) => {
    if (!timeStr) return "";
    const date = new Date(timeStr);
    const now = new Date();
    const diff = now - date;

    if (diff < 60000) {
      return t('messageCenter.time.justNow');
    } else if (diff < 3600000) {
      return t('messageCenter.time.minutesAgo', { count: Math.floor(diff / 60000) });
    } else if (diff < 86400000) {
      return t('messageCenter.time.hoursAgo', { count: Math.floor(diff / 3600000) });
    } else {
      return date.toLocaleDateString();
    }
  };

  // 跳转到消息对话页面
  const goToChat = (message) => {
    console.log("跳转到聊天页面，订单ID:", message.orderId);
    // 这里需要根据实际的聊天页面路由进行跳转
    // 假设聊天页面路由为 /chat/:orderId
    history.push(`/messageCenter/chat/${message.orderId}`, {
      orderType: message.orderType,
      passengerPhone: message.passengerPhoneSuffix,
    });
  };


  return (
    <div className="message-center">
      <div className="message-content">
        <PullToRefresh onRefresh={onRefresh}>
          <List>
            {messageList.map((message, index) => (
              <List.Item
                key={`${message.id}-${index}`}
                className="message-item chat-style"
                onClick={() => goToChat(message)}
              >
                <div className="chat-row">
                  <div className="chat-avatar">
                    <img src={messageImg} alt="乘客头像" />
                  </div>
                  <div className="chat-main">
                    <div className="chat-header">
                      <span className="chat-title">
                        乘客({message.passengerPhoneSuffix}) · {getOrderTypeText(message.orderType)}
                      </span>
                      <span className="chat-time">{formatTime(message.createTime)}</span>
                    </div>
                    <div className="chat-content">
                      {parseMessageContent(message.msgContent, message.msgType)}
                    </div>
                  </div>
                  {message.readStatus === 0 && message.msgSource === 1 && (
                    <div className="chat-unread"></div>
                  )}
                </div>
              </List.Item>
            ))}

          </List>

          {messageList.length === 0 && !loading && (
            <div className="empty-state">
              <div className="empty-icon">
                <i className="iconfont icon-message"></i>
              </div>
              <div className="empty-text">{t('messageCenter.noMessages')}</div>
            </div>
          )}

          {hasMore && messageList.length > 0 && (
            <div className="load-more" onClick={loadMore}>
              {loading ? t('messageCenter.loading') : t('messageCenter.loadMore')}
            </div>
          )}
        </PullToRefresh>
      </div>
    </div>
  );
};

export default MessageCenter;
